<div class="page">
     <div class="content-wrapper">

  <div class="section-header">CRITICAL INSIGHTS</div>
       <div class="insights-container">
           <div class="metrics-column">
               <!-- <div class="metric-item" *ngFor="let metric of metricsData; let i = index">
                   <img [src]="getMetricIcon(i)" class="metric-icon" *ngIf="i < 3">
                   <div class="status-dot" [style.background-color]="getStatusColor()" *ngIf="i === 3"></div>
                   <div class="metric-content">
                       <div class="metric-value">{{ metric.value }}</div>
                       <div class="metric-label">{{ metric.label }}</div>
                   </div>
               </div> -->
           </div>

           <div class="alerts-column">
  <div class="alert-item" *ngFor="let highlight of highlights | slice: 10">
    <div class="alert-icon" [class.positive]="highlight.isPositive">
      <fa-icon [icon]="highlight.isPositive ? ['fas', 'plus-square'] : ['fas', 'minus-square']"></fa-icon>
    </div>
    <div class="alert-content">
      <div class="alert-title">{{ highlight.title }}</div>
      <div class="alert-desc">{{ highlight.description }}</div>
    </div>
  </div>
</div>

         </div>

  <div *ngIf="shouldShowSalesPerformance()">
     <div class="section-header">SALES PERFORMANCE INSIGHTS</div>
           <div class="performance-section">
               <div class="performance-label">COMPARING BY ESTIMATED SALES VOLUME</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.byVolume">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>

               <div class="performance-label">COMPARING BY ESTIMATED SALES/SQFT</div>
               <div class="performance-row">
                   <div class="perf-item" *ngFor="let item of salesPerformance.bySqft">
                       <div class="perf-canvas">
                           <canvas width="40" height="40"
                                   [attr.data-percentile]="item.percentile"
                                   [attr.data-color]="item.color"
                                   class="mini-chart"></canvas>
                           <div class="perf-percentile">{{ item.percentile }}</div>
                       </div>
                       <div class="perf-text">
                           <div class="perf-prefix">This Store is a</div>
                           <div class="perf-title">{{ item.status }}</div>
                           <div class="perf-subtitle">{{ item.description }}</div>
                       </div>
                   </div>
               </div>
           </div>
  </div>
</div>

  </div>
